import { ApiSchemas } from '..'
import { wrapEndpoint } from '../wrap'
import { client } from '../client'

export default {
  async list(query?: ApiSchemas['ListTreatmentComorbidityDto']) {
    return wrapEndpoint(() =>
      client.GET('/treatment-comorbidity', {
        params: {
          query,
        },
      }),
    )
  },
}
